import HCPReportDashboard from '../pages/HCPReportDashboard';

const hcpDashboardRoute = {
  public: [],
  auth: [
    {
      name: 'hcp_dashboard',
      path: '/dashboard/hcp',
      permissions: ['HTAM', 'NSM-HOSPITAL', 'SD', 'EXECUTIVE'],
      component: HCPReportDashboard,
    },
  ],
};

export default hcpDashboardRoute;
